import type { ReactNode } from "react";
import "./drawer.css";
import { Icon } from "../icon";

interface DrawerProps {
  isOpen: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
}

export default function Drawer({
  footer,
  isOpen,
  title,
  onClose,
  children,
}: DrawerProps) {
  return (
    <>
      <div
        className={`drawer-overlay ${isOpen ? "open" : ""}`}
        onClick={onClose}
      />

      <aside className={`drawer ${isOpen ? "open" : ""}`}>
        <header className="drawer-header">
          <h2>{title}</h2>

          <button
            className="drawer-close"
            onClick={onClose}
          >
            <Icon name={"close"}></Icon>
          </button>
        </header>

        <div className="drawer-content">
          {children}
        </div>
        {footer && (
        <footer className="drawer-footer">
            {footer}
        </footer>
        )}
      </aside>
    </>
  );
}